import React, { CSSProperties, forwardRef } from 'react';
import * as S from './styles';
import { IconeBusca } from '@/components/atoms/Icones/IconeBusca';
import { useTheme } from 'styled-components';

export type SearchFieldSize = 1 | 2;
export type SearchFieldVariant = 'surface' | 'soft';
export type SearchFieldState =
  | 'placeholder'
  | 'hover'
  | 'active'
  | 'filled'
  | 'disable'
  | 'read-only';

export type SearchFieldProps = {
  $size: SearchFieldSize;
  $variant: SearchFieldVariant;
  $state: SearchFieldState;
  $label: boolean;
  $helperText?: string;
  $focusRing: boolean;
  $placeholder: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  style?: CSSProperties;
  $inputProps?: object;
  $iconeBuscaProps?: {
    color: string;
  };
};

const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>(
  (props, ref) => {
    const theme = useTheme();

    const {
      style,
      $size,
      $state,
      $placeholder,
      $variant,
      onChange,
      $inputProps,
      $iconeBuscaProps = {
        color: theme.colors.neutral.neutral_alpha[9],
      },
    } = props;
    const propsContainer = { $size, $state, $variant };

    return (
      <S.Container style={style} {...propsContainer}>
        <IconeBusca
          size={theme.typography.font.size[$size === 1 ? 3 : $size + 2]}
          color={$iconeBuscaProps.color}
        />
        <S.Input
          ref={ref}
          onChange={onChange}
          type="text"
          placeholder={$placeholder}
          {...$inputProps}
        />
      </S.Container>
    );
  },
);

SearchField.displayName = 'SearchField';

export default SearchField;
